import request from '../utils/request'

export default {
	async synthesize(data) {
		return await request('/v1/tts/synthesize', data, 'POST')
	},
	async voices() {
		return await request('/v1/tts/voices', {}, 'POST')
	}
}
